import { useAuthorizationStatus } from '@mos-utils/acs-react';
import { ReactNode, useEffect } from 'react';
import acs from '@mos-utils/acs';
import { connect } from 'dva';

interface Props {
  dispatch(action: { type: string }): { type: string };
  children: ReactNode;
}

function AuthCheck({ dispatch, children }: Props): Props['children'] | null {
  const value = useAuthorizationStatus();

  useEffect(() => {
    if (value === 'unauthorized') return acs.login(window.location.href);
    if (value === 'authorized') {
      dispatch({ type: 'auth/getUserAuth' });
      return;
    }
  }, [dispatch, value]);

  return value === 'unknown' ? children : null;
}

export default connect()(AuthCheck);
